import type { IconData } from '@stacksjs/iconify-core'

export const snowflake: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m135.279 206.728l88.857 51.595l-80.039 46.474l-95.789-25.668v33.13l74.847 20.054l-20.165 75.258l28.69 16.564l23.838-88.966L240 286.115v88.287l-71.177 71.177l28.69 16.565L258 401.657l59.135 59.135l28.691-16.564L272 370.402v-84.287l83.002 48.195l24.277 90.604l28.691-16.565l-20.374-76.036L464 311.841v-33.129l-96.492 25.855l-79.644-46.244l88.463-51.366L464 230.449V197.32l-69.654-18.663l19.23-71.769l-28.69-16.565l-23.69 88.416L272 230.53v-99.962l66.833-66.833l-28.69-16.564l-55.172 55.172l-54.307-54.306l-28.69 16.564L240 132.627v97.903l-90.675-52.65l-23.252-86.777l-28.691 16.564l19.022 70.99l-68.096 18.246v33.129z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default snowflake
